import { create } from 'zustand';

type MicrosoftData = {
  isMicrosoftConnected: boolean;
  setIsMicrosoftConnected: (value: boolean) => void;
};

export const useStoreMicrosoftData = create<MicrosoftData>(set => ({
  isMicrosoftConnected: false,
  setIsMicrosoftConnected: (isMicrosoftConnected: boolean) =>
    set(() => ({ isMicrosoftConnected })),
}));
